export default {"src":"/_next/static/media/icon-code.c36844b0.svg","height":24,"width":25,"blurWidth":0,"blurHeight":0};